export class ActivateAccountModel {
  public id: string;
  public password: string;
  public confirmPassword: string;
  public token: string;
}
